import {
    SimpleShowLayout,
    TextField,
    useResourceContext,
    usePermissions,
} from "react-admin";
import { queryToAttribute } from "shared/src/utils/decodeQuery";
import { ToolbarWithHistory } from "shared/src/components/ToolbarWithHistory";
import { AccessRightsError } from "shared/src/components/AccessRightsError";
import { RaShowView } from "shared/src/components/views/RaShowView";
import { AddressFormShow } from "../components/AddressFormShow";

export const SupplierShow = (props) => {
    const resource = useResourceContext();
    const attribute = queryToAttribute();
    const { isLoading, permissions } = usePermissions();

    if (isLoading) {
        return <></>;
    } else if (!permissions.vote({ resource, attribute })) {
        return <AccessRightsError />;
    }
    return (
        <RaShowView
            {...props}
            actions={<ToolbarWithHistory back={true} edit={true} />}
        >
            <SimpleShowLayout>
                <TextField label="equip.name" source="name" />
                <AddressFormShow />
            </SimpleShowLayout>
        </RaShowView>
    );
};
